import { Box, styled, useTheme } from "@mui/material";
import { HEADER, NAV } from "../../config";

import ChooseCodeLanguage from "../../components/ChooseCodeLanguage";
import PageMap from "../../page/PageMap/PageMap";
import Header from "../Header/Index";
// import Scrollbar from "@/components/scrollbar";
import { useEffect, useState } from "react";
import useResponsive from "@/hooks/useResponsive";

const SPACING = 0;

export default function Index() {
  const theme = useTheme();
  const isMobile = !useResponsive("up", "lg");
  const [flag, setFlag] = useState("");

  useEffect(() => {
    const scrollable = document.querySelector("#test-scroll") as HTMLDivElement;
    if (scrollable) {
      const observer = new IntersectionObserver(
        (entries, observer) => {
          for (const item of entries) {
            if (item.isIntersecting) {
              setFlag("down");
              break;
            } else {
              setFlag("up");
            }
          }
        },
        {
          root: scrollable,
          threshold: [0.2, 0.5],
        }
      );
      const intersections = document.querySelectorAll(".intersection-dark-box");
      intersections.forEach((v) => observer.observe(v));

      return () => {
        observer.disconnect();
      };
    }
  }, []);

  return (
    <Box
      sx={{
        // mt: `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`,
        width: `calc(100% - ${NAV.W_DASHBOARD}px)`,
        ml: `${NAV.W_DASHBOARD}px`,
        backgroundColor:
          theme.palette.mode === "light"
            ? theme.palette.background.default
            : theme.palette.grey[700],
        minHeight: "100%",
        paddingBottom: "1px",
        position: "relative",
        zIndex: 10,
        [theme.breakpoints.down("lg")]: {
          width: "100%",
          ml: 0,
          minHeight: "100vh",
        },
      }}
      id="scroll-box"
    >
      <Header />
      <Box
        sx={{
          height: isMobile
            ? "100vh"
            : `calc(100vh - ${HEADER.H_DASHBOARD_DESKTOP_OFFSET + 1}px)`,
          overflow: "hidden",
          position: "relative",
          paddingTop: isMobile ? "60px" : "0",
        }}
      >
        {!isMobile && <DarkBox className="dark-box" />}

        <Box
          sx={{
            height: 1,
            overflow: "auto",
            position: "relative",
          }}
          id="test-scroll"
        >
          {!isMobile && (
            <DarkBoxBg>
              <ChooseCodeLanguageBox>
                <ChooseCodeLanguage />
              </ChooseCodeLanguageBox>
            </DarkBoxBg>
          )}

          {isMobile && flag === "down" && (
            <MboileChooseCodeLanguageBox>
              <ChooseCodeLanguage sx={{ mb: 0 }} />
            </MboileChooseCodeLanguageBox>
          )}

          <PageMap />
        </Box>
      </Box>
    </Box>
  );
}

const DarkBox = styled(Box)(({ theme }) => ({
  width: "40%",
  position: "absolute",
  // right: 0,
  left: "60%",
  bottom: 0,
  // top: `${HEADER.H_DASHBOARD_DESKTOP_OFFSET + SPACING}px`,
  top: 0,
  backgroundColor: theme.palette.grey[800],
  zIndex: -1,
}));

const DarkBoxBg = styled(Box)(({ theme }) => ({
  // width: "40%",
  width: "33%",
  position: "absolute",
  left: "60%",
  top: `0px`,
  backgroundColor: "transparent",
  zIndex: 2,
  height: "70px",
}));

const ChooseCodeLanguageBox = styled(Box)(({ theme }) => ({
  position: "fixed",
  width: "calc(40% - 124px)",
  // width: "40%",
  top: `${HEADER.H_DASHBOARD_DESKTOP_OFFSET + SPACING}px`,
  backgroundColor: theme.palette.grey[800],
  zIndex: 999,
  paddingLeft: "16px",
  paddingTop: "12px",
  height: "70px",
}));

const MboileChooseCodeLanguageBox = styled(Box)(({ theme }) => ({
  position: "fixed",
  top: "80px",
  marginLeft: "20px",
  zIndex: 999,
}));
